import { AvailableCreditCard } from "@fero/components";
import type { BigDecimal } from "adl-gen/common";
import type { SettlementCreditDetails } from "adl-gen/ferovinum/app/settlementcredit";

type Props = {
  organisationCredit: SettlementCreditDetails;
  currencyFormatter: {
    format(val: BigDecimal): string;
  };
};

export const OrganisationCreditCards = ({
  organisationCredit,
  currencyFormatter,
}: Props) => {
  return (
    <AvailableCreditCard
      totalCredit={organisationCredit.creditLimit}
      availableCredit={organisationCredit.creditLimitAvailable}
      usedCredit={organisationCredit.creditLimitUsed}
      formatter={currencyFormatter.format}
    />
  );
};
